// extracted by mini-css-extract-plugin
export default {"search-trend-rankers-form":"search-trend-rankers-form_iYHcg"};